/**
 * An event decoded from the BTM run stream. Optional fields cover text, tool,
 * state, and terminal events.
 */
export interface ConversationalBtmStreamEvent {
  type: string;
  messageId?: string;
  parentMessageId?: string;
  role?: string;
  delta?: string;
  toolCallId?: string;
  toolCallName?: string;
  content?: unknown;
  message?: string;
  code?: string;
  name?: string;
  value?: unknown;
  result?: unknown;
  runId?: string;
  threadId?: string;
  [key: string]: unknown;
}

/** A single Server-Sent Events record parsed from the BTM stream response. */
export interface ConversationalBtmSseRecord {
  id?: string;
  event?: string;
  data: string;
  retry?: number;
}

/** The terminal run outcome tracked by the client event reducer. */
export type ConversationalBtmTerminalStatus = 'finished' | 'error' | null;

/**
 * Checks whether decoded SSE data contains the required BTM event discriminator.
 *
 * @param value - Decoded JSON from an SSE `data` field.
 * @returns Whether the value is a BTM stream event.
 */
export function isConversationalBtmStreamEvent(
  value: unknown
): value is ConversationalBtmStreamEvent {
  return (
    value !== null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    typeof (value as { type?: unknown }).type === 'string'
  );
}
